import { render } from "./Main.vue?vue&type=template&id=e6e6f34e"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render

export default script